<template>
  <div style="display: flex;flex-direction: column;align-items: center">
    <div style="display: flex;flex-direction: column;width: 100%">
      <div v-for="(item, index) in zxList" @click="onClick(item)">
        <div :class="index % 2 === 0 ? 'info_title_quiz' : 'info_title_quiz2'">
          <div
            style="margin-top:15px;display: flex;flex-direction: row;width: 100%;align-items: center;margin-bottom: 15px">
            <img style="width: 30px;height: 30px;border-radius: 50%" :src="item.userInfo.imageUrl"
                 :onerror="defaultImg">
            <a style="color: #666666;margin-left: 10px">{{ userCheck(item.userInfo.nickname) }}</a>
            <div style="color: #666666;margin-left: auto">{{ delTimeTag(item.commentTime) }}</div>
          </div>
          <div style="width: 100%;display: flex;flex-direction: row">
            <a style="color: #ffbc42; font-weight: bold;">{{ '[' + item.question_page_title + ']' }}</a>
            <a
              style="color: #333333;margin-left: 5px;max-width: 860px; text-overflow: ellipsis; overflow: hidden;white-space: nowrap;font-size: 15px">{{
                item.reviewContent
              }}</a>
            <a v-if="item.hasAnswered === 1" style="color: #999999;margin-left:auto">{{ '(已回答)' }}</a>
          </div>
          <div v-if="item.subjectInfo.subjectDes"
               style="background-color: #f2f2f2;color:#999999;border-radius: 8px;padding: 10px;margin-top: 10px;width: 100%;">
            {{ delHtmlTag(item.subjectInfo.subjectDes) }}
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 20px;margin-bottom: 20px">
      <el-button v-if="!freeLoadComplete" type="primary" @click="menu">
        加载更多
        <i class="el-icon-arrow-down"></i>
      </el-button>
      <el-button v-if="freeLoadComplete">已经到底部，没有更多啦~</el-button>
    </div>
  </div>
</template>

<script>
import userPhoto from "../../common/imgs/default_icon.png";
import {getMyQuizData} from "../../networks/QuizRequestHandler";

export default {
  name: "PersonalQuiz",
  data() {
    return {
      zxList: [],
      freeLoadComplete: false,
      pageNum: 1,
    }
  },
  created: function () {
    this.getData()
  },
  computed: {
    defaultImg() {
      return 'this.src="' + userPhoto + '"';
    }
  },
  methods: {
    getData: function (isMore) {
      var context = this;
      var promise = getMyQuizData(context.pageNum);
      promise.then(function (r) {
        if (isMore) {
          if (r.myQuestionInfo.length === 0) {
            context.freeLoadComplete = true;
          } else {
            context.zxList = context.zxList.concat(r.myQuestionInfo);
          }
        } else {
          context.zxList = r.myQuestionInfo;
        }
        console.log(context.zxList)
      }).catch(function (error) {
      });
    },
    delHtmlTag: function (str) {
      return str.replace(/<[^>]+>/g, "");
    },
    delTimeTag: function (str) {
      return str.replace('T', " ");
    },
    userCheck: function (str) {
      if ($.isEmptyObject(str)) {
        str = '必胜用户'
      }
      return str
    },
    onClick: function (item) {
      this.$router.push({path: "/quiz/quiz_id/" + item.commentId})
      console.log(item.commentId)
    },
    menu: function () {
      this.pageNum++;
      this.getData(true);
    }
  }
}
</script>

<style>

.el-aside {
  color: #333;
  text-align: center;
}

.title {
  font-weight: normal;
  border-bottom: 1px #f2f2f2 solid;
}

.info_title_quiz {
  background-color: #ffffff;
  color: #555555;
  font-size: 14px;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  flex-direction: column;
  align-items: center;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.info_title_quiz2 {
  background-color: #f8f8f8;
  color: #555555;
  font-size: 14px;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  flex-direction: column;
  align-items: center;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.area-list {
  float: left;
  padding: 0;
  padding-right: 10px;
  list-style: none;
}

.area_text_non {
  width: 50px;
  text-align: center;
}

.area_text {
  font-weight: bold;
  width: 50px;
  text-align: center;
  color: #ffbc42;
}

</style>



// WEBPACK FOOTER //
// src/components/Personal/PersonalQuiz.vue